import * as React from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: theme.spacing(18.25),
    '&:focus': {
      backgroundColor: 'white'
    },
    '& .MuiSelect-outlined': {
      padding: theme.spacing(1)
    },
    ...theme.typography.body1
  },
  selected: {},
  menuItem: {
    ...theme.typography.body1,
    color: theme.palette.text.primary,
    '&$selected': {
      backgroundColor: `${theme.palette.grey[200]} !important`,
      '&:hover': {
        backgroundColor: theme.palette.grey[200]
      }
    },
    '&:hover': {
      backgroundColor: theme.palette.common.white
    }
  }
}));

type SourceDropDownProps = {
  value: string;
  onChange: (event: SelectChangeEvent) => void;
  disabled: boolean;
  options: {
    id: string;
    name: string;
  }[];
};

const SourceDropDown: React.FC<SourceDropDownProps> = ({
  value,
  onChange,
  disabled,
  options
}: SourceDropDownProps) => {
  const classes = useStyles();
  return (
    <Box>
      <Select
        value={value}
        onChange={onChange}
        className={classes.root}
        variant="outlined"
        disabled={disabled}
        data-testid="source-drop-down"
      >
        {(options || []).map((i) => {
          return (
            <MenuItem
              key={i.id}
              value={i.id}
              classes={{ selected: classes.selected, root: classes.menuItem }}
              selected={value === i.id ? true : false}
              autoFocus={value === i.id ? true : false}
              data-testid={`source-drop-down-option-${i.id}`}
            >
              {i.name}
            </MenuItem>
          );
        })}
      </Select>
    </Box>
  );
};
export default SourceDropDown;
